import { Action, createReducer, on } from '@ngrx/store'
import { EmployeeState, initialEmployeeState } from '../state/employee.state'
import { CLEAR_EMPLOYEE_BANKING_INFO, FETCH_EMPLOYEE_BANKING_INFO_SUCCESS } from '../action/employee.action'

export function employeeReducer(state: EmployeeState, action: Action) {
  return _employeeReducer(state, action)
}

const _employeeReducer = createReducer(
  initialEmployeeState,
  on(FETCH_EMPLOYEE_BANKING_INFO_SUCCESS, (state, { bankingInfo }) => {
    return {
      ...state,
      bankingInfo: bankingInfo
    }
  }),
  on(CLEAR_EMPLOYEE_BANKING_INFO, (state, {}) => {
    return {
      ...state,
      bankingInfo: undefined
    }
  })
)
